/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { logout } from "config/firebaseWithFirestore";
import { logoutSuccess, logoutError, loginError } from "redux/actions/Login";

export default function FromOutsideWithToken(props) {
    const [tokenData, setTokenData] = useState(undefined);
    const { b64token } = useParams();

    const history = useHistory();
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.Login);

    useEffect(() => {
        if (b64token) {
            const tokenDataString = atob(b64token);
            setTokenData(JSON.parse(tokenDataString));
        }
    }, [b64token]);

    function doLogout() {
        logout()
            .then(() => {
                dispatch(logoutSuccess());
                localStorage.clear();
            })
            .catch((error) => dispatch(logoutError(error.message)));
    }

    function validateTokenUser(token) {
        if (user.id === token.assigneeUserId) {
            return true;
        }

        dispatch(
            loginError(
                "Not authorized to see this content! Make sure that the user you are logged in, is the same one that received the notification email."
            )
        );
        doLogout();
        return false;
    }

    useEffect(() => {
        if (user) {
            if (tokenData && tokenData.type === "goToModule") {
                if (validateTokenUser(tokenData)) {
                    history.push(`/${tokenData.module}?fileCaseId=${tokenData.fileCaseId}`);
                }
            }

            if (tokenData && tokenData.type === "goToHome") {
                if (validateTokenUser(tokenData)) {
                    if (tokenData.taskId) {
                        history.push(`/open-task/${tokenData.taskId}`);
                    } else {
                        history.push(`/`);
                    }
                }
            }
        } else {
            if (b64token) {
                history.push(`/login?td=true&d=${b64token}`);
            }
        }
    }, [user, tokenData]);

    return <div>Redirecting...</div>;
}
